export const OfferIcon = ({
  strokeColor = "var(--color-stroke-active)",
  ...props
}: any) => (
  <svg width="38" height="50" viewBox="0 0 38 50" fill="none">
    <rect
      x="0.797872"
      y="0.797933"
      width="36.0233"
      height="48.4043"
      rx="5.58511"
      fill="white"
      stroke={strokeColor}
      strokeWidth="1.59574"
    />
    <line
      x1="31.7382"
      y1="43.9767"
      x2="25.4059"
      y2="43.9767"
      stroke={strokeColor}
      strokeWidth="3.19149"
      strokeLinecap="round"
    />
    <line
      x1="32.5361"
      y1="36.9893"
      x2="5.08424"
      y2="36.9893"
      stroke={strokeColor}
      strokeWidth="1.59574"
      strokeLinecap="round"
    />
    <line
      x1="32.5342"
      y1="33.1798"
      x2="5.08228"
      y2="33.1798"
      stroke={strokeColor}
      strokeWidth="1.59574"
      strokeLinecap="round"
    />
    <line
      x1="32.5361"
      y1="29.3692"
      x2="5.08424"
      y2="29.3692"
      stroke={strokeColor}
      strokeWidth="1.59574"
      strokeLinecap="round"
    />
    <line
      x1="32.5342"
      y1="25.5587"
      x2="5.08228"
      y2="25.5587"
      stroke={strokeColor}
      strokeWidth="1.59574"
      strokeLinecap="round"
    />
    <line
      x1="32.5361"
      y1="21.7501"
      x2="5.08424"
      y2="21.7501"
      stroke="var(--color-stroke-active)"
      strokeWidth="1.59574"
      strokeLinecap="round"
    />
    <line
      x1="32.5342"
      y1="17.9415"
      x2="5.08228"
      y2="17.9415"
      stroke="var(--color-stroke-active)"
      strokeWidth="1.59574"
      strokeLinecap="round"
    />
    <line
      x1="32.5361"
      y1="14.1319"
      x2="5.08424"
      y2="14.1319"
      stroke="var(--color-stroke-active)"
      strokeWidth="1.59574"
      strokeLinecap="round"
    />
    <line
      x1="17.7724"
      y1="10.3204"
      x2="5.08247"
      y2="10.3204"
      stroke="var(--color-stroke-active)"
      strokeWidth="1.59574"
      strokeLinecap="round"
    />
  </svg>
);
